export enum VideoAdUnitCode {
    video = "video",
    clickToPlayVideo = "clickToPlayVideo",
    unblockedContentVideo = "unblockedContentVideo"
}
